import { useEffect, useState } from 'react';
import { disablePush, enablePush, isStandalone, pushState, PushState } from './notifications';
import { isApp } from '../native/env';

/*
 * Карточка настройки уведомлений.
 *
 * Главное здесь — честно объяснить айфону: пока приложение не добавлено на
 * домашний экран, Safari не пропустит ни одного уведомления. Без этой
 * подсказки половина команды осталась бы без сообщений и вернулась в Telegram.
 */

export function NotificationsCard() {
  const [state, setState] = useState<PushState | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const refresh = () => pushState().then(setState).catch(() => {});
  useEffect(() => {
    refresh();
  }, []);

  if (isApp()) {
    return (
      <div className="tile ch-push">
        <b>Уведомления в приложении</b>
        <p className="sub">Уведомления на телефон появятся в следующем обновлении приложения.</p>
      </div>
    );
  }
  if (!state) return null;
  if (state.subscribed && state.permission === 'granted') {
    return (
      <div className="banner ok">
        <b>Уведомления включены</b>
        <span className="sub">Сообщения приходят, даже когда приложение закрыто.</span>
        <button
          className="btn outline sm"
          onClick={async () => {
            setBusy(true);
            await disablePush();
            await refresh();
            setBusy(false);
          }}
          disabled={busy}
        >
          Выключить
        </button>
      </div>
    );
  }

  if (state.needsInstall) {
    return (
      <div className="tile ch-push">
        <b>Уведомления на айфоне</b>
        <p className="sub">
          Safari присылает уведомления только установленному приложению. Нажмите «Поделиться» внизу
          экрана, выберите «На экран „Домой“», затем откройте ERP с домашнего экрана и включите
          уведомления здесь же.
        </p>
      </div>
    );
  }

  if (!state.supported) {
    return (
      <div className="tile ch-push">
        <b>Уведомления недоступны</b>
        <p className="sub">Этот браузер не умеет присылать уведомления при закрытом окне.</p>
      </div>
    );
  }

  return (
    <>
      <div className="banner crit">
        <b>Уведомления выключены</b>
        <span className="sub">
          {isStandalone()
            ? 'Пока они выключены, сообщения при закрытом приложении не приходят.'
            : 'Пока они выключены, сообщения при закрытой вкладке не приходят.'}
        </span>
        <button
          className="btn outline sm"
          disabled={busy || !state.configured}
          onClick={async () => {
            setBusy(true);
            setError('');
            const problem = await enablePush();
            if (problem) setError(problem);
            await refresh();
            setBusy(false);
          }}
        >
          Включить
        </button>
      </div>
      {error && <div className="banner crit">{error}</div>}
      {!state.configured && <p className="sub mute">На сервере не заданы ключи уведомлений</p>}
    </>
  );
}
